import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../services/i18n/i18nSlice"

import img_bell from '../../assets/images/notifiche.svg'

import { useEffect, useState } from "react"
import { setLoading, setNavbarHide, setNavbarHideMobile } from "../../services/global/globalSlice"
import { TitleH1 } from "../../components/TitleH1"
import { selectAppInfo } from "../../services/utils/appInfoSlice"
import { loadUserProfileData } from "../../features/User/userSlice"
import { Text } from "../../components/Text"
import SecureImage from "../../components/_partials/SecuredImage"
import { API_URL } from "../../config/constants"
import { TitleH2 } from "../../components/TitleH2"

import './NotificationScreen.css'
import { Button } from "../../components/Button"
import { fetchGetNotifications } from "../../features/Notification/notificationApi"
import { loadCurrentNotificationDebounced } from "../../features/Notification/notificationSlice"

export default function NotificationScreen () {

    const t = useSelector(selectTranslations)
    const appInfo = useSelector(selectAppInfo)
    const dispatch = useDispatch()

    const [fetchData, setFetchData] = useState({next_cursor: null})
    const [communicationsData, setCommunicationsData] = useState([])

    useEffect(()=>{
        dispatch(setNavbarHideMobile(false))
        dispatch(setNavbarHide(false))
        dispatch(setLoading(false))
        if(appInfo.is_ofa)
            dispatch(loadUserProfileData())
        if(appInfo?.personalizations?.enabled_sections?.notifications)
            dispatch(loadCurrentNotificationDebounced()) 
    },[])

    const loadCommunications = async () => {
        let response = await fetchGetNotifications({
            ...(fetchData?.next_cursor && {
                next_cursor: fetchData?.next_cursor
            })
        })
        if(response.success){
            setCommunicationsData([...communicationsData, ...response?.data?.communications])
            setFetchData({next_cursor: communicationsData?.next_cursor})
        }
    }

    useEffect(()=>{
        loadCommunications()
    },[])

    return (
        <section className="content_section">
            <TitleH1 className="page_title">{t.notifications.page_title}</TitleH1>
            <Text>{t.notifications.page_description}</Text>
            <section id="notifications">
                <Text>Per te</Text>
                {
                    communicationsData?.map((comm, i)=>{
                        if(!comm?.folder_id)
                            return(
                                <div className="communication" key={comm?.communication_id}>
                                    <div className="icon">
                                        {
                                            comm?.icon_image_url ?
                                                <SecureImage imageUrl={`${API_URL}${comm?.icon_image_url}`} height="20px" width="20px" className="w-100" />
                                            :
                                                <img src={img_bell} className="w-100" />
                                        }
                                    </div>
                                    <div className="content">
                                        <TitleH2>{comm?.title}</TitleH2>
                                        <Text>{comm.text}</Text>
                                        {
                                            comm?.cta &&
                                            <a href={comm?.cta?.url} target="_blank">
                                                <Button>
                                                    {comm?.cta?.title}
                                                </Button>
                                            </a>
                                        }
                                    </div>
                                </div>
                            )
                    })
                }
            </section>
        </section>
        
    )
}